var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "选择物流",
        visible: _vm.dialogVisible,
        width: "350px",
        "before-close": _vm.handleCancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { attrs: { model: _vm.form, inline: true } },
        [
          _c("el-form-item", { attrs: { label: "出库通知单号" } }, [
            _vm._v(" " + _vm._s(_vm.form.code) + " "),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "选择物流" } },
            [
              _c("BjSelectLogisticBusiness", {
                staticClass: "full-width",
                attrs: { placeholder: _vm.$t("chooseText") },
                on: { change: _vm.onBusiness },
                model: {
                  value: _vm.form.logisticBusinessId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "logisticBusinessId", $$v)
                  },
                  expression: "form.logisticBusinessId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "快递单号" } },
            [
              _c("BjInputCode", {
                staticClass: "full-width",
                attrs: { placeholder: "请输入快递单号" },
                model: {
                  value: _vm.form.trackingNumber,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "trackingNumber", $$v)
                  },
                  expression: "form.trackingNumber",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v(_vm._s(_vm.$t("cancelText"))),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSend } },
            [_vm._v(_vm._s(_vm.$t("okText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }